import { DocumentReviewTab } from 'src/constants/document-review/enums'

/**
 * The queue tab to show. A tab is only rendered with its view permission, so a requested tab the
 * reviewer can't see (or an unknown `?tab=` value) falls back to the one they can; `null` when
 * they can see neither queue. Same shape as `resolveInternalAccessTab`.
 */
export const resolveDocumentReviewQueueTab = (
  requested: string | null,
  canViewContractor: boolean,
  canViewMc: boolean,
): DocumentReviewTab | null => {
  if (requested === DocumentReviewTab.MasterContractor && canViewMc) {
    return DocumentReviewTab.MasterContractor
  }

  if (canViewContractor) {
    return DocumentReviewTab.Contractor
  }

  if (canViewMc) {
    return DocumentReviewTab.MasterContractor
  }

  return null
}
